import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ChevronsUpDown, Check, X } from "lucide-react";

export function SelezionaCommessa({ commesse, value, onChange, testid = "sel-commessa", placeholder = "Nessuna (solo magazzino)" }) {
  const [open, setOpen] = useState(false);
  const sel = commesse.find((c) => c.id === value);
  return (
    <div className="flex gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" role="combobox" className="w-full justify-between font-normal" data-testid={testid}>
            <span className="truncate">{sel ? `${sel.codice} · ${sel.cliente_nome || ""} — ${sel.descrizione}` : placeholder}</span>
            <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-[520px]" align="start">
          <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
            <CommandInput placeholder="Cerca per codice o cliente…" data-testid={`${testid}-search`} />
            <CommandList>
              <CommandEmpty>Nessuna commessa trovata.</CommandEmpty>
              <CommandGroup>
                {commesse.map((c) => (
                  <CommandItem key={c.id} value={`${c.codice} ${c.cliente_nome || ""} ${c.descrizione}`} onSelect={() => { onChange(c.id); setOpen(false); }} data-testid={`${testid}-opt-${c.codice}`}>
                    <Check className={`mr-2 h-4 w-4 ${value === c.id ? "opacity-100" : "opacity-0"}`} />
                    <span className="font-mono text-xs mr-2">{c.codice}</span><span className="font-medium mr-2">{c.cliente_nome}</span><span className="text-slate-500 truncate">{c.descrizione}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      {value && <Button variant="ghost" size="icon" onClick={() => onChange("")} title="Rimuovi" data-testid={`${testid}-clear`}><X className="h-4 w-4" /></Button>}
    </div>
  );
}
